import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from './Modal';
import { messengers as messengersApi, errorMessage } from '../utils/api';
import { useAuth } from '../context/AuthContext';

/**
 * اتصال حساب تلگرام/بله برای دریافت اعلان‌های سامانه در چت.
 *
 * لینکِ اتصال در بات باز می‌شود (نه اینجا)، پس این کامپوننت نمی‌تواند
 * لحظه‌ی موفقیت را مستقیم ببیند — دکمه‌ی «بررسی وضعیت» به همین دلیل هست:
 * پروفایل را دوباره می‌خواند و اگر وصل شده بود نشان می‌دهد.
 */

const PROVIDERS = [
  { id: 'telegram', label: 'تلگرام', icon: '✈️' },
  { id: 'bale', label: 'بله', icon: '🔵' },
];

export default function MessengerLink() {
  const [open, setOpen] = useState(false);
  const { user, refreshUser } = useAuth();

  const linked = user?.messengers || {};

  return (
    <>
      <button type="button" className="btn btn--ghost btn--sm" onClick={() => setOpen(true)}>
        💬 اتصال تلگرام/بله
      </button>

      <Modal open={open} title="اتصال پیام‌رسان" onClose={() => setOpen(false)} width={420}>
        <p className="plink__hint" style={{ marginTop: 0 }}>
          با اتصال، اعلان‌های سامانه (ارسال گزارش، نیاز به اصلاح، تأیید و…) در
          کنار تابلوی وب، به همین چت هم می‌آید.
        </p>

        {PROVIDERS.map((p) => (
          <MessengerRow
            key={p.id}
            provider={p}
            linkInfo={linked[p.id]}
            onChanged={refreshUser}
          />
        ))}
      </Modal>
    </>
  );
}

function MessengerRow({ provider, linkInfo, onChanged }) {
  const [deepLink, setDeepLink] = useState(null);
  const [busy, setBusy] = useState(false);

  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await messengersApi.linkToken(provider.id);
      setDeepLink(data.deep_link);
      window.open(data.deep_link, '_blank', 'noopener');
    } catch (err) {
      toast.error(errorMessage(err, 'ساخت لینک اتصال ناموفق بود.'));
    } finally {
      setBusy(false);
    }
  };

  const unlink = async () => {
    setBusy(true);
    try {
      await messengersApi.unlink(provider.id);
      toast.success('اتصال قطع شد.');
      setDeepLink(null);
      onChanged();
    } catch (err) {
      toast.error(errorMessage(err, 'قطع اتصال ناموفق بود.'));
    } finally {
      setBusy(false);
    }
  };

  const check = async () => {
    setBusy(true);
    await onChanged();
    setBusy(false);
  };

  return (
    <div className="plink" style={{ marginBottom: 10 }}>
      <div className="plink__head">
        <span className="plink__title">{provider.icon} {provider.label}</span>
        {linkInfo && <span className="plink__source">وصل — @{linkInfo.username || '—'}</span>}
      </div>

      {linkInfo ? (
        <button type="button" className="btn btn--ghost btn--sm" disabled={busy} onClick={unlink}>
          قطع اتصال
        </button>
      ) : (
        <div className="plink__row" style={{ flexWrap: 'wrap', gap: 8 }}>
          <button type="button" className="btn btn--primary btn--sm" disabled={busy} onClick={connect}>
            اتصال در {provider.label}
          </button>
          {deepLink && (
            <button type="button" className="btn btn--ghost btn--sm" disabled={busy} onClick={check}>
              بررسی وضعیت اتصال
            </button>
          )}
        </div>
      )}
    </div>
  );
}
